import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = { class: "p-field-label" }
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_4 = { class: "p-field-radiobutton" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.TypeOfObject")), 1),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.typeOptions, (type) => {
      return (_openBlock(), _createBlock("div", {
        key: `option-${type}`
      }, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_RadioButton, {
            id: `option-${type}`,
            name: "option",
            value: type,
            modelValue: _ctx.roomObject.lightType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.roomObject.lightType = $event))
          }, null, 8, ["id", "value", "modelValue"]),
          _createVNode("label", {
            for: `option-${type}`
          }, _toDisplayString(_ctx.getOptionName(type)), 9, ["for"])
        ])
      ]))
    }), 128))
  ]))
}